<div class="filter-box grid">
  <div class="xs-12 m-2 title">{{'product-category.product-category' | i18next}}</div>
  <div class="xs-12 m-10">
    <div class="product-category">
      <div *ngFor='let category  of categories' class="product-category pill"
           (click)="handleProductCategorySelected(category.key)"
           [ngClass]="{'selected': productCategoriesSelected[category.key]}">
        {{category.name}}
      </div>
    </div>
  </div>
</div>
